'use client';
import React from 'react';
import { IBaseResponse } from '@/lib/apiBase';

import * as Icon from '@/ui/Icon';
import { Row, Stack } from '@/ui/primatives';
import { colors } from '@/styles';

import EntryStatusTag from '@/components/Repository/RepositoryCompare/EntryStatusTag';

import * as Styled from './styled';
// import JsonView from '../JsonView';

export interface IDirectoryDiff extends IBaseResponse {
  dirs: IDiffDirectory[];
}

type TDirItem = {
  name: string;
  status: 'added' | 'removed' | 'modified';
};

interface IDiffDirectory {
  can_display: boolean;
  children: TDirItem[];
  name: string;
  num_subdirs: number;
  status?: 'added' | 'removed' | 'modified';
}

const InsetSpacer: React.FC<{ inset: number }> = ({ inset }) => {
  return <div style={{ width: inset * 16 }}></div>;
};

const DirectoryNode: React.FC<{
  dir: IDiffDirectory | TDirItem;
  inset: number;
  selectedDir?: string;
  onFolderSelect: (path: string) => void;
  rootNodeName?: string;
}> = ({ dir, inset, selectedDir, onFolderSelect, rootNodeName = '...' }) => {
  const { status, name } = dir;
  const isSelected = selectedDir === dir.name;
  const displayName = name ? name.split('/')[name.split('/').length - 1] : rootNodeName;

  return (
    <Styled.DirectoryNode $selected={isSelected} onClick={() => onFolderSelect(dir.name)}>
      <div>
        <InsetSpacer inset={inset} />
        <Row gap={5} alignItems="center">
          <Icon.GithubFolder className="folder-icon" open={isSelected} />
          <span>{displayName}</span>
        </Row>
      </div>
      {status && <EntryStatusTag status={status} />}
    </Styled.DirectoryNode>
  );
};

const DirectoryDiffTree: React.FC<{
  response: IDirectoryDiff;
  selectedDir?: string;
  onFolderSelect?: (path: string) => void;
  rootNodeName?: string;
}> = ({ response, selectedDir, onFolderSelect, rootNodeName = '...' }) => {
  const onFolderClick = (path: string) => {
    if (onFolderSelect) {
      onFolderSelect(path);
    }
  };

  const topLevelDir = response.dirs.filter((dir) => dir.name === '');
  const parentDirs = response.dirs.filter((dir) => dir.name !== '');

  const DisplayDir: React.FC<{ dir: IDiffDirectory; inset: number }> = ({ dir, inset = 0 }) => {
    return (
      <Stack gap={10}>
        <DirectoryNode
          dir={dir}
          inset={inset}
          selectedDir={selectedDir}
          onFolderSelect={onFolderClick}
          rootNodeName={rootNodeName}
        />
        {dir.children.map((child) => {
          const parentDir = parentDirs.find((parentDir) => parentDir.name === child.name);
          return parentDir ? (
            <DisplayDir key={child.name} dir={parentDir} inset={inset + 1} />
          ) : (
            <DirectoryNode
              key={child.name}
              dir={child}
              inset={inset + 1}
              selectedDir={selectedDir}
              onFolderSelect={onFolderClick}
            />
          );
        })}
      </Stack>
    );
  };

  return (
    <Styled.DirectoryDiffTree>
      {/* <JsonView json={response} rootNodeName="response" /> */}
      <div style={{ maxWidth: 300 }}>
        <DisplayDir dir={topLevelDir[0]} inset={0} />
      </div>
      {/* <pre>{JSON.stringify(response, null, 2)}</pre> */}
    </Styled.DirectoryDiffTree>
  );
};

export default DirectoryDiffTree;
